export const seoKeywords = {
  name: 'keywords',
  content:
    'web development company, web development services, custom web development, web design and development, client portal development, custom software development, custom web portal',
};

export const webDevelopmentPageSeo = {
  title: 'Web Development Company | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish offers custom web development services tailored precisely to your business needs and requirements. Need a unique web application development? Or maybe your product is a huge platform with lots of integration required to work properly? No matter what your concept is, we’ve got you covered!',
    },
  ],
};
